import { View, ViewOpts } from '@play-co/timestep-core/ui';
import gsap from 'gsap';
import { Avatar } from 'src/game/components/shared/Avatar';
import { getPlayerProfileAvatarFrame } from 'src/replicant/profile/profile.getters';
import { user } from 'src/StateObserver';

export default class StreakMatchmakingPlayersV2 extends View {
  private players: View[] = [];
  private timeline!: gsap.core.Timeline;
  private playerShown = 0;

  public get count() {
    return this.players.length;
  }

  constructor(opts: ViewOpts) {
    super(opts);
  }

  public setup(players: { id: string; photo?: string }[]) {
    this.stopAnimation();
    this.players.forEach((player) => player.removeFromSuperview());
    this.players.length = 0;
    this.playerShown = 0;

    const duration = 0.5;
    const size = 94;
    const rows = 3;
    const spacing = -5;
    const spacingY = 25;
    this.timeline = gsap.timeline();

    for (let row = 1; row <= rows; row++) {
      const amount = row + 3 * (row - 1);
      for (let index = 0; index < amount; index++) {
        const rowWidth = size * amount + spacing * (amount - 1);
        const offsetX = rowWidth * 0.5 - size * 0.5;
        const offsetY = Math.abs((amount + 1) * 0.5 - (index + 1)) * spacingY;
        const rowIndex = row - 1;
        const x = index * (size + spacing) - offsetX;
        const y = offsetY - rowIndex * (50 + 15 * rowIndex);
        const scale = 1 - rowIndex * 0.2;
        const player = players[rowIndex + index];
        const wrapper = new View({
          superview: this,
          zIndex: rows - row,
          scaleX: scale * 1.1,
          scaleY: scale * 0.8,
          opacity: row > 1 ? 0 : 1,
        });
        const me = user().id === player.id;
        const avatar = new Avatar({
          superview: wrapper,
          x,
          y,
          width: size,
          height: size,
          borderTint: user().id === player.id ? '#FFF503' : undefined,
          dropShadow: { offsetY: 5 },
          frame: me ? getPlayerProfileAvatarFrame(user()) : 'default',
        });
        avatar.updateOpts({ opacity: row < rows ? 1 : 0.6 });
        avatar.updateImage(player.photo ?? '');
        this.players.push(wrapper);

        const timestamp = Math.random() * 0.5;
        this.timeline
          .to(
            wrapper.style,
            {
              duration,
              y: -40,
              ease: 'quad.out',
              repeat: -1,
              yoyo: true,
            },
            timestamp,
          )
          .to(
            wrapper.style,
            {
              duration,
              scaleX: scale,
              scaleY: scale,
              ease: 'power5.out',
              repeat: -1,
              yoyo: true,
            },
            timestamp,
          );
      }
    }
  }

  public showNextPlayer() {
    if (this.playerShown >= this.players.length - 1) return;
    this.playerShown++;
    gsap.to(this.players[this.playerShown].style, {
      duration: 0.5,
      opacity: 1,
      ease: 'quad.inOut',
    });
  }

  public stopAnimation() {
    this.timeline?.kill();
  }
}
